const account_center = {
    not_enabled: 'El centro de cuentas no está habilitado.',
    field_not_editable: 'El campo no es editable.',
};
export default Object.freeze(account_center);
